import { Colors, typographyStyle, Flex } from '@revenuemarket/cds';
import { mixpanelTrack } from '@revenuemarket/utils/mixpanel';
import { Typography } from 'antd';
import { useRouter } from 'next/router';

import { TermOffered } from '~apis/dashboard';
import { useGetFinanceInfo } from '~hooks/queries/dashboard/query';
import { useCompanyId } from '~hooks/useCompanyId';
import { css } from '~libs/emotion';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';

interface Props {
  companyName: string;
}

const NavFinanceBanner = ({ companyName }: Props) => {
  const { companyId } = useCompanyId();

  const router = useRouter();
  const { data } = useGetFinanceInfo({
    companyId,
  });

  const termOffered = data?.Data?.data?.items.find(
    (item) => item?.type === 'TERM_OFFERED',
  ) as TermOffered;

  const payoutLimit = termOffered?.payoutLimit ?? 0;

  return (
    <Flex
      className={css`
        border-radius: 16px;
        background: ${Colors.white};
        box-shadow: 0px 8px 16px 0px rgba(29, 34, 37, 0.02);
        width: 100%;
        margin-top: 8px;
        padding: 8px 8px 8px 16px;
        cursor: pointer;
        &:hover {
          background: ${Colors.gray200};
          box-shadow: none;
        }
      `}
      gap={8}
      align="center"
      onClick={() => {
        mixpanelTrack(MIXPANEL_EVENT.FINANCE.CLICK_NAV_BANNER);
        router.push('/clobe/loans');
      }}
    >
      <Flex direction="column" gap={2}>
        <Flex align="center" wrap="wrap">
          <Typography.Text
            style={{ maxWidth: 125, ...typographyStyle['13_400'], color: Colors.gray800 }}
            ellipsis
          >
            {companyName}
          </Typography.Text>
          <Typography.Text style={{ ...typographyStyle['13_400'], color: Colors.gray800 }}>
            의 대출한도
          </Typography.Text>
        </Flex>
        <Typography.Text
          style={{ width: 125, ...typographyStyle['14_600'], color: Colors.gray800 }}
          ellipsis
        >
          {payoutLimit.toLocaleString()}원
        </Typography.Text>
      </Flex>
    </Flex>
  );
};

export default NavFinanceBanner;
